/**
 * The forced password change after a temporary password (Tom, 2026-10-08, job #236).
 *
 * `app_metadata.must_change_password` is set by scripts/issue-temporary-passwords.mjs
 * and cleared by api/auth/set-new-password.ts. app_metadata is writable only by the
 * service role, so a person cannot lift the gate by editing their own metadata.
 */
export function mustChangePassword(
  user: { app_metadata?: Record<string, unknown> | null } | null | undefined,
): boolean {
  return user?.app_metadata?.must_change_password === true
}
